
import { USERS_GROUPS,ASSIGN_USER_GROUPS,GROUP_DROPDOWN } from '../lib/constants/api-urls';
import Api from "../lib/api-call";
import {changeParamsToQuery} from './commonFn';

export class UsersGroupsService {

  static instance;


  static getInstance() {
    if (!UsersGroupsService.instance) {
      UsersGroupsService.instance = new UsersGroupsService();
    }
    return UsersGroupsService.instance;
  }

  createUserGroup = async (params) => {
    let newsResponse = (params.id && params.isDelete) ?await Api.delete(`${USERS_GROUPS.URL}`, params):(params.id) ? await Api.put(`${USERS_GROUPS.URL}`, params):await Api.post(`${USERS_GROUPS.URL}`, params);
    return newsResponse;
  }

  fetchUsersGroups = async (params) => {
    let newsResponse = await Api.get(`${USERS_GROUPS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchUsersGroupsArray = async (params) => {
    let newsResponse = await Api.get(`${GROUP_DROPDOWN.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  assignUserGroups = async (params) => {
    let newsResponse = await Api.post(`${ASSIGN_USER_GROUPS.URL}`, params);
    return newsResponse;
  }




}

